let injected = false;

/** Injects the Google AdSense loader script once, only if a client ID is configured. */
export function loadAdSenseScript() {
  if (injected) return;
  const clientId = import.meta.env.VITE_ADSENSE_CLIENT_ID as string | undefined;
  if (!clientId) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
  injected = true;
}
